import {useCallback, useEffect, useMemo, useState} from "react";
import {TICKET_SEPARATOR_OPTIONS, TicketSeparatorMode} from "./ticketDataGridSeparators";

function readMode(key: string, fallback: TicketSeparatorMode): TicketSeparatorMode {
  try {
    const saved: unknown =
      typeof window === "undefined" ? undefined : JSON.parse(window.localStorage.getItem(key) ?? "null");
    return TICKET_SEPARATOR_OPTIONS.find((option) => option.value === saved)?.value ?? fallback;
  } catch {
    return fallback;
  }
}

export function useTicketSeparatorMode(key: string, defaultMode: TicketSeparatorMode = "NONE") {
  const [stored, setStored] = useState(() => ({key, mode: readMode(key, defaultMode), dirty: false}));
  const mode = useMemo(
    () => (stored.key === key ? stored.mode : readMode(key, defaultMode)),
    [stored, key, defaultMode]
  );
  useEffect(() => {
    if (!stored.dirty) return;
    try {
      window.localStorage.setItem(stored.key, JSON.stringify(stored.mode));
    } catch {
      /* Keep controls usable without storage. */
    }
  }, [stored]);
  const setMode = useCallback((mode: TicketSeparatorMode) => setStored({key, mode, dirty: true}), [key]);
  return {mode, setMode};
}
